import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';

import getTask from '@/api/teacher/getTask.endpoint';
import expandTaskMiniactivities from '@/modules/activities/expandMiniactivies';
import useTaskTheme from '@/v2/domains/Tasks/hooks/useTaskTheme.hook';

export default function useGetTaskQuery({ taskId }) {
  const { getTaskTheme } = useTaskTheme();

  return useQuery({
    queryKey: [QUERY_KEYS.TASKS, parseInt(taskId)],
    queryFn: async () => {
      const task = await getTask(taskId);
      task.taskActivities = expandTaskMiniactivities(task.taskActivities);
      return task;
    },
    select: (task) => {
      const theme = getTaskTheme(task);
      return {
        ...task,
        taskTemplate: {
          ...task.taskTemplate,
          theme,
        },
        theme,
      };
    },
    enabled: !!taskId,
    refetchOnWindowFocus: false,
    meta: {
      notification: {
        error: "We couldn't load the task. Please try again.",
      },
    },
  });
}
